import React from "react";
import SuspenseWrapper from "@/router/component/SuspenseWrapper";

// Route path and component name mapping
const routeConfigs = [
  { path: "/preOnboarding", component: "PreOnboarding" },
  { path: "/probation", component: "Probation" },
  { path: "/durationMonths", component: "DurationMonths" },
  { path: "/separationReason", component: "SeparationReason" },
  { path: "/bankName", component: "BankName" },
  { path: "/webLocation", component: "WebLocation" },
  { path: "/attendanceFormat", component: "AttendanceFormat" },
  { path: "/weekOff", component: "WeekOff" },
  { path: "/leaveScheme", component: "LeaveScheme" },
  { path: "/shift", component: "Shift" },

  // 🔽 Newly added pages
  { path: "/swipeMethod", component: "SwipeMethod" },
  { path: "/pf", component: "PF" },
  { path: "/experiences", component: "Experience" },
  { path: "/maritalStatus", component: "MaritalStatus" },
  { path: "/relationship", component: "Relationship" },
  { path: "/languages", component: "Languages" },
  { path: "/industryType", component: "IndustryType" },

  // new pages
  { path: "/asset", component: "Asset" },
  { path: "/experienceYears", component: "ExperienceYears" },
  { path: "/experienceMonths", component: "ExperienceMonths" },
  { path: "/probationMonths", component: "ProbationMonths" },

  // not yet implemented in backend
  { path: "/religion", component: "Religion" },
  { path: "/primarySkill", component: "PrimarySkill" },
  { path: "/secondarySkill", component: "SecondarySkill" },

  // removed TownDetails as per the request
  // { path: "/townDetails", component: "TownDetails" },
];

// Dynamic lazy component mapping
const lazyComponents = {
  PreOnboarding: React.lazy(() =>
    import("@/pages/moduleSettings/pages/PreOnboarding")
  ),

  Probation: React.lazy(() => import("@/pages/moduleSettings/pages/Probation")),

  DurationMonths: React.lazy(() =>
    import("@/pages/moduleSettings/pages/DurationMonths")
  ),
  SeparationReason: React.lazy(() =>
    import("@/pages/moduleSettings/pages/SeparationReason")
  ),
  BankName: React.lazy(() => import("@/pages/moduleSettings/pages/BankName")),
  WebLocation: React.lazy(() =>
    import("@/pages/moduleSettings/pages/WebLocation")
  ),
  AttendanceFormat: React.lazy(() =>
    import("@/pages/moduleSettings/pages/AttendanceFormat")
  ),
  WeekOff: React.lazy(() => import("@/pages/moduleSettings/pages/WeekOff")),
  LeaveScheme: React.lazy(() =>
    import("@/pages/moduleSettings/pages/LeaveScheme")
  ),
  Shift: React.lazy(() => import("@/pages/moduleSettings/pages/Shift")),

  // 🔽 Lazy load new pages
  SwipeMethod: React.lazy(() =>
    import("@/pages/moduleSettings/pages/SwipeMethod")
  ),
  PF: React.lazy(() => import("@/pages/moduleSettings/pages/PF")),
  Experience: React.lazy(() =>
    import("@/pages/moduleSettings/pages/Experience")
  ),
  MaritalStatus: React.lazy(() =>
    import("@/pages/moduleSettings/pages/MaritalStatus")
  ),
  Relationship: React.lazy(() =>
    import("@/pages/moduleSettings/pages/Relationship")
  ),
  Languages: React.lazy(() => import("@/pages/moduleSettings/pages/Languages")),
  IndustryType: React.lazy(() =>
    import("@/pages/moduleSettings/pages/IndustryType")
  ),

  // new pages

  Asset: React.lazy(() => import("@/pages/moduleSettings/pages/Asset")),
  ExperienceYears: React.lazy(() =>
    import("@/pages/moduleSettings/pages/ExperienceYears")
  ),
  ExperienceMonths: React.lazy(() =>
    import("@/pages/moduleSettings/pages/ExperienceMonths")
  ),
  ProbationMonths: React.lazy(() =>
    import("@/pages/moduleSettings/pages/ProbationMonths")
  ),

  // not yet implemented in backend
  Religion: React.lazy(() => import("@/pages/moduleSettings/pages/Religion")),
  PrimarySkill: React.lazy(() =>
    import("@/pages/moduleSettings/pages/PrimarySkill")
  ),

  SecondarySkill: React.lazy(() =>
    import("@/pages/moduleSettings/pages/SecondarySkill")
  ),

  // TownDetails: React.lazy(() =>
  //   import("@/pages/moduleSettings/pages/TownDetails")
  // ),
};
// Final route definitions
const Index = routeConfigs.map(({ path, component }) => ({
  path,
  element: (
    <SuspenseWrapper>
      {React.createElement(lazyComponents[component])}
    </SuspenseWrapper>
  ),
}));

export default Index;
